module.exports = __webpack_public_path__ + "static/img/roboy.bc3ab0b8.png";